// extracted by mini-css-extract-plugin
module.exports = {"modal":"GenericModal_modal__221fa","modalHeader":"GenericModal_modalHeader__32gck"};